import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { FeatureFlags, FeatureFlagService } from '../services/feature-flag.service';
import { SessionService } from '../services/session.service';
import { VegWizardStateMachineService } from './services/veg-wizard-state-machine.service';

@Component({
  template: '',
  standalone: true,
})
export abstract class BaseWizardComponent {
  // Public property for FeatureFlags
  public FeatureFlags = FeatureFlags;

  // Using inject() to access services directly
  private sms = inject(VegWizardStateMachineService);
  private ssc = inject(SessionService);
  private featureFlagService = inject(FeatureFlagService);
  protected router = inject(Router);

  /**
   * Navigate to the next page in the veg wizard
   */
  next() {
    this.sms
      .getNext$()
      .pipe(first()) // Automatically complete after the first emission
      .subscribe((route) => {
        this.router.navigate(['/', route]);
      });
  }

  /**
   * Navigate to the previous page in the veg wizard
   */
  previous() {
    this.sms
      .getPrev$()
      .pipe(first()) // Automatically complete after the first emission
      .subscribe((route) => {
        this.router.navigate(['/', route]);
      });
  }

  /**
   * Cancel and reset session
   */
  cancel() {
    if (confirm('Are you sure?') === true) {
      this.ssc.destroyAndResetSession();
    }
  }

  /**
   * Check if a feature flag is enabled
   */
  featureFlag(feature: FeatureFlags): boolean {
    return this.featureFlagService.featureEnabled(feature);
  }
}
